import React from 'react'
import * as XLSX from 'xlsx'
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";

class GetDataFromExcelJusTInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hoja: "",
      hojas:[],
      file: false
    };

    this.handleInputChange = this.handleInputChange.bind(this)
  }
handleInputChange = async (event) => {
  const target = event.target;
  const value = target.type === "checkbox" ? target.checked : target.value;
  const name = target.name;

  this.setState({
    [name]: value,
  });

  if (name !== "file") return;

  try {
    const file = target.files?.[0];
    if (!file) return;

    let reader = new FileReader();

    reader.onloadend = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        let hojas = [];

        workbook.SheetNames.forEach((sheetName) => {
          const XL_row_object = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName]
          );

          hojas.push({
            data: XL_row_object,
            sheetName,
          });
        });

        console.log("HOJAS:", hojas);

        const A1 = hojas?.[0]?.data || [];

        if (A1.length === 0) {
          Swal.fire("Error", "El archivo no tiene información", "error");
          return;
        }

        const confirmar = await Swal.fire({
          title: "¿Subir artículos?",
          text: `Se subirán ${A1.length} artículos`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sí, subir",
          cancelButtonText: "Cancelar",
        });

        if (!confirmar.isConfirmed) return;

        Swal.fire({
          title: "Subiendo artículos...",
          text: "Por favor espera",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const headers = {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        };

        const clean = (value, defaultValue = "") => {
          if (value === undefined || value === null) return defaultValue;
          const v = String(value).trim();
          return v === "" ? defaultValue : v;
        };

        const cleanNumber = (value, defaultValue = 0) => {
          const n = Number(value);
          return isNaN(n) ? defaultValue : n;
        };

        const toArrayIds = (value) => {
          if (!value || value === "NA") return [];

          return String(value)
            .split(",")
            .map((x) => x.trim())
            .filter((x) => x && x !== "NA");
        };

        let creados = 0;
        let errores = [];

        for (const a of A1) {
          try {
            await axios.post(
              `${process.env.REACT_APP_URL_ARTICULOS}`,
              {
                fotoDiseno: clean(a.fotoDiseno, "No"),
                fotoArticulo: clean(a.fotoArticulo, "No"),

                compradores: a.compradores,
                colaboradores: a.colaboradores,
                marcas: a.marcas,
                colecciones: a.colecciones,
                colores: toArrayIds(a.colores),
                clientes: a.clientes,
                tallas: toArrayIds(a.tallas),
                catalogoProcesos: toArrayIds(a.catalogoProcesos),
                patronista: a.patronista,
                muestrista: a.muestrista,
                ploter: a.ploter,

                departamentos: a.departamentos,
                subDepartamentos: a.subDepartamentos,
                clases: a.clases,
                subClases: a.subClases,

                fecha: "2026-05-08",

                descripcion: clean(a.descripcion, "NA"),
                codigo: clean(a.codigo, "NA"),
                codigoCliente: clean(a.codigoCliente),
                costo: cleanNumber(a.costo, 0),
                codigoSAT: clean(a.codigoSAT, "NA"),
                codigoUnidad: clean(a.codigoUnidad, "NA"),
              },
              { headers }
            );

            creados++;
          } catch (error) {
            errores.push({
              codigo: a.codigo,
              descripcion: a.descripcion,
              error: error?.response?.data || error.message,
            });
          }
        }

        this.setState({
          selectedFileDocument: file,
          hojas,
        });

        Swal.close();

        if (errores.length > 0) {
          console.log("Errores al subir artículos:", errores);

          Swal.fire({
            icon: "warning",
            title: "Proceso terminado con errores",
            html: `
              <b>Artículos creados:</b> ${creados}<br/>
              <b>Errores:</b> ${errores.length}<br/>
              Revisa la consola para ver el detalle.
            `,
          });
        } else {
          Swal.fire(
            "Listo",
            `Se crearon ${creados} artículos correctamente`,
            "success"
          );
        }
      } catch (error) {
        Swal.close();
        console.log(error);

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Ocurrió un error leyendo el archivo",
        });
      }
    };

    reader.readAsArrayBuffer(file);
  } catch (error) {
    console.log(error);

    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Ocurrió un error al cargar el archivo",
    });
  }
};


  
  render() {

    const {
      handleInputChange
    } = this
    return (
      <>
        <input 
            required 
            type="file" 
            name="file" 
            id="file" 
            onChange={handleInputChange} 
            placeholder="Archivo de excel" 
        />
      </>
    );
  }
}

export default GetDataFromExcelJusTInput

